export const EVENTS_ACTIONS = {
    FETCH_EVENTS: 'fetch',
    ADD_EVENT: 'add',
    UPDATE_EVENT: 'update',
    DELETE_EVENT: 'delete'
}

export const eventsReducer = (state, action) => {
    switch (action.type) {
        case EVENTS_ACTIONS.FETCH_EVENTS: {
            return { ...state, events: action.payload }
        }
        case EVENTS_ACTIONS.ADD_EVENT: {
            const newState = {
                ...state,
                events: [...state.events, action.payload]
            }
            return newState
        }
        case EVENTS_ACTIONS.UPDATE_EVENT: {
            const newState = {
                ...state,
                events: state.events.map(item => {
                    if (item.id === action.payload.id) return action.payload
                    return item
                })
            }
            return newState
        }
        case EVENTS_ACTIONS.DELETE_EVENT: {
            const newState = {
                ...state,
                events: state.events.filter(event => event.id !== action.payload.id)
            }
            return newState
        }
        default:
            return state
    }
}